export default __webpack_public_path__ + "static/media/warning--soft-shoulder--g4.6b309255.png";